<template>
  <div class="index container">
    <transition name="fade">
      <router-view @showParent="showParent"> </router-view>
    </transition>

    <div v-if="showParentPage">
      <v-breadcrumbs>
        <v-breadcrumbs-item :exact="true" :to="{ name: 'home', params: {} }"
          >Home</v-breadcrumbs-item
        >
        <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
        <v-breadcrumbs-item
          :exact="true"
          :to="{ name: 'staff', params: {} }"
          active
        >
          Staff
        </v-breadcrumbs-item>
      </v-breadcrumbs>

      <div class="d-flex flex-column flex-md-row">
        <div class="flex-grow-1 mb-5">
        <v-text-field
          dense
          v-model="searchTerms"
          @keyup.enter="search"
          @click:clear="clearSearch"
          @click:append="search"
          placeholder="Press enter to begin search"
          append-icon="mdi-magnify"
          outlined
          clearable
          label="Search by staff name"
          hide-details
        />
          <v-switch @change="search" dense hide-details v-model="activeOnly" label="Active staff only"/>
        </div>
        <div class="d-flex flex-row">
        <v-select label="Filter Status" @change="search" v-model="requirementStatus" class="ml-md-4" :style="`${$vuetify.breakpoint.mdAndUp ? 'max-width: 200px;':''}`" dense outlined v-if="requirementStatus" :items="['All', 'Completed', 'Incomplete']"/>
        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn class="ml-4" color="primary" v-bind="attrs" v-on="on">Create</v-btn>
          </template>
          <v-card class="mx-auto" max-width="400" width="200" tile>
            <v-list dense>
              <v-list-item-group color="primary">
                <v-list-item
                  :to="{ name: 'staffCreate', params: {} }"
                >
                  <v-list-item-content>
                    <v-list-item-title>New staff</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <!-- <v-list-item
                  :to="{ name: 'staffUpload', params: {} }"
                >
                  <v-list-item-content>
                    <v-list-item-title>Upload staffs</v-list-item-title>
                  </v-list-item-content>
                </v-list-item> -->
              </v-list-item-group>
            </v-list>
          </v-card>
        </v-menu>
        
        </div>
      </div>

      <div class="table-container">
        <v-data-table
          :headers="headers"
          :items="staffList"
          :items-per-page="pagination.pageSize"
          :loading="!staffProcessed"
          :server-items-length="pagination.totalSize"
          :page="pagination.current"
          :disable-pagination="!staffList || staffList.length < 1"
          :hide-default-header="!staffList || staffList.length < 1"
          :hide-default-footer="!staffList || staffList.length < 1"
          :disable-sort="true"
          item-key="id"
          class="elevation-1"
          :options.sync="options"
          @update:options="pageChanged"
        >
          <template v-slot:item.firstName="{ item }">
            <a @click="view(item)">{{ item.firstName }} {{ item.lastName }}</a>
            <div class="text-caption font-weight-light">
              <span v-if="globalCenter && !globalCenter.id">
                {{getCenterName(item.centerId)}} - 
              </span>
              {{item.contactTypeName}} <span v-if="!item.active"><v-divider vertical/>(Inactive)</span>
            </div>
          </template>

          <template v-slot:item.requirements="{ item }">
            <v-skeleton-loader v-if="loadingRequirement" type="list-item" />
            <div v-else class="text-subtitle-2 font-weight-light">
            {{getstaffRequirementStatus(item.id)}}
            </div>
          </template>

          <template v-slot:item.lastUpdate="{ item }">
            {{getLastUpdate(item.id) | formatDateYear}}
          </template>
        </v-data-table>
      </div>
    </div>
    <confirmation-dialog ref="confirm" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { getStaffRequirements } from "@/services/requirement";
const ConfirmationDialog = () =>
  import("@/components/common/ConfirmationDialog.vue");

export default {
  data() {
    return {
      pagination: {
        current: 1,
        pageSize: 10,
        totalSize: 100
      },
      options: {
        //define default sorting option here.
        sortBy: [],
        sortDesc: []
      },
      loadingRequirement: true,
      staffList: [],
      showParentPage: true,
      staff2Requirements: new Map(),
      staff2LastUpdate: new Map(),
      headers: [
        {
          text: "Name",
          value: "firstName",
          align: "start",
          sortable: true
        },
        {
          text: "Requirements",
          value: "requirements",
          align: "start",
          sortable: true
        },
        {
          text: "Last Update",
          value: "lastUpdate",
          align: "start",
          sortable: true
        },
      ],
      sort: {
        key: null
      },
      searchTerms: ""
    };
  },
  components: {
    ConfirmationDialog
  },
  computed: {
    ...mapGetters("staff", ["staffProcessed", "getStaff"]),
    ...mapGetters("auth", ["myCenters"]),
    ...mapGetters("navigation", ["isAppLoading", "globalCenter"]),

    allRequirementComplete(){
      if(this.requirementStatus == "Completed" ){
        return true;
      }
      else if(this.requirementStatus == "Incomplete" ){ return false }
      else{ return null; }
    },
    activeOnly: {
      get() {
        return this.$store.state.staff.params['activeOnly']
      },
      set(value) {
        this.$store.state.staff.params['activeOnly'] = value;
      }
    },
    requirementStatus: {
      get() {
        return this.$store.state.staff.params['requirementStatus']
      },
      set(value) {
        this.$store.state.staff.params['requirementStatus'] = value;
      }
    }
  },
  methods: {
    ...mapActions("messages", [
      "addErrorMessage",
      "addMessage",
      "addSuccessMessage"
    ]),
    ...mapActions("staff", ["deletestaff", "fetchStaff"]),
    view(item) {
      this.$router.push({ name: "staffView", params: { id: item.id } });
    },
    getResources() {
      //skip if parent page is not showing...
      if(!this.showParentPage){
        return;
      }

      this.loadingRequirement = true;
      //default to sorting by ID desc if not defined
      const sortBy =
        this.options["sortBy"] && this.options["sortBy"].length > 0
          ? this.options.sortBy[0]
          : "id";
      const sortDesc =
        this.options["sortDesc"] && this.options["sortDesc"].length > 0
          ? this.options.sortDesc[0]
          : true;

      const params = {
        page:
          this.pagination.pageIndex && this.pagination.pageIndex > 0
            ? this.pagination.pageIndex - 1
            : 0,
        size: this.pagination.pageSize,
        sort: `${sortBy}${sortDesc ? ",desc" : ""}`,
        searchTerms: this.searchTerms ? this.searchTerms.replace(/\s+/g, ' ').trim() : null,
        activeOnly: this.activeOnly,
        allRequirementComplete: this.allRequirementComplete
      };

      this.fetchStaff(params)
        .then(response => {
          if (response) {
            this.pagination.totalSize = response.totalElements;
            this.staffList = response.content;

            const staffIds = this.staffList.map(s => s.id);
            this.loadstaffRequirements(staffIds)
              .then(response => {
                this.staff2Requirements = response;
                this.loadingRequirement = false;
              })
              .catch(error => {
                console.error(error)
                this.addErrorMessage('Error loading requirement status for staff')
                this.loadingRequirement = false;
              })
          }
        })
        .catch(error => {
          this.loadingRequirement = false;
          this.addErrorMessage("Server response with error " + error);
        });
    },
    showParent(show) {
      this.showParentPage = show;
    },
    pageChanged(pagination) {
      this.pagination.pageIndex = pagination.page;
      this.pagination.pageSize = pagination.itemsPerPage;

      this.getResources();
    },
    search() {
      this.getResources();
    },
    clearSearch() {
      this.searchTerms = null;
      this.getResources();
    },
    async loadstaffRequirements(staffIds){
      const ids = staffIds && staffIds.length > 0 ? staffIds.join(",") : null;
      if(ids){
        return getStaffRequirements(ids)
          .then(response => {
            const requirements = response.data;
            let staff2Requirements = new Map();
           
            if(requirements && requirements.length > 0){
              staff2Requirements = requirements.reduce((map, r) => {
                const staffId = r.staffId;
                let completedCount = 0;
                let incompleteCount = 0;
                const statuses = r.status ? Object.values(r.status):[];

                if(r.status){
                  completedCount = statuses.filter(s => s.state == 'completed' || s.state == 'pending').length;
                  incompleteCount = statuses.filter(s => s.state == 'incomplete').length;
                }

                if(map.has(staffId)){
                  map.get(staffId).completedCount += completedCount;
                  map.get(staffId).incompleteCount += incompleteCount;
                  map.get(staffId).requirements.push(r);
                }
                else{
                  map.set(staffId, {requirements: [r], completedCount, incompleteCount});
                }

                // update last updated time staff
                const lastUpdate = statuses.reduce((max, s) => {
                  if(s.submissionDate){
                    const lastUpdate = this.parseISOLocalDate(s.submissionDate);
                    if(max == null || (lastUpdate && max < lastUpdate)){
                      max = lastUpdate;
                    }
                  }
                  return max;
                }, null)

                const staffLastUpdate = this.staff2LastUpdate.get(staffId);
                if( staffLastUpdate == null || ( lastUpdate != null && staffLastUpdate < lastUpdate)){
                  this.staff2LastUpdate.set(staffId, lastUpdate);
                }

                return map;
              }, new Map())
            }
  
            return staff2Requirements;
          })
      }
      else{ 
        return null;
      }
    },
    getstaffRequirementStatus(staffId){
      if(this.staff2Requirements){
        const status = this.staff2Requirements.get(staffId);
        if(status){
          const totalCount = status.incompleteCount + status.completedCount;
          return `${status.completedCount} of ${totalCount} requirements completed`
        }
        else{ 
          return 'n/a'
        }
      }
    },
    getLastUpdate(staffId){
      if(this.staff2Requirements){
        return this.staff2LastUpdate.get(staffId);
      }
      else{ return null }
    },
    parseISOLocalDate(s){
      var b = s.split(/\D/);
      return new Date(b[0], b[1] - 1, b[2]);
    },
    getCenterName(id){
      if(this.myCenters && this.myCenters.length > 0){
        const center = this.myCenters.find(c => c.id == id);
        return center ? center.name:'Location N/A';
      }
      else{ return 'Location N/A'; }
    }
  },
  watch: {
    "pagination.numberRegisterForPage": function() {
      this.pagination.current = -1;
    }
  },
  beforeRouteUpdate(to, from, next) {
    const toDepth = to.path.split("/").length;
    const fromDepth = from.path.split("/").length;
    this.showParentPage = toDepth < fromDepth;
    if (this.showParentPage) {
      this.getResources();
    }
    next();
  }
};
</script>
